$(document).ready(function() {
	
	$("select[other-option-value]").each(function(){
		if($(this).val() != $(this).attr('other-option-value'))
		{
			$(this).parent().parent().find("input[name=fault]").parent().addClass('hidden');
		}
	});

	$(document).on("change", "select[other-option-value]", function() {
		
		if($(this).val() == $(this).attr('other-option-value'))
		{
			$(this).parent().parent().find("input[name=fault]").parent().removeClass('hidden');
		}
		else {
			$(this).parent().parent().find("input[name=fault]").parent().addClass('hidden');
		}
	});

});